import React from 'react';
import { TextInput } from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';

interface Props {
  form: any;
}

const EditInspectionDetailsForm = (props: Props) => {
  const { form } = props;

  return (
    <>
      <TextInput label={'Nazwa'} name="name" mb={20} {...form.getInputProps('name')} />
      <DateTimePicker
        label={'Rozpoczęty'}
        name="startedAt"
        mb={20}
        {...form.getInputProps('startedAt')}
      />
      <DateTimePicker
        label={'Zakończony'}
        name="finishedAt"
        mb={20}
        {...form.getInputProps('finishedAt')}
      />
    </>
  );
};

export default EditInspectionDetailsForm;
